import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);

new Vue({
  render: h => h(App),
}).$mount('#app')



